import { UnifiedAlarmGroup } from '@hakimo-ui/hakimo/types';
import useAuthenticatedRequest from '../shared/useAuthenticatedRequest';

export function useSharedAlarmGroup(sharedToken: string) {
  const host = window.location.hostname;
  const baseUrl =
    host === 'localhost'
      ? `http://${host}:${window.location.port}`
      : `https://event-flow-${host}`;

  const url = `${baseUrl}/shared/api/alarm_group?sharedToken=${sharedToken}`;
  const request = new Request(url);

  return useAuthenticatedRequest<UnifiedAlarmGroup>(request, {
    queryKey: ['alarm_group_details', 'shared', sharedToken],
    responseModifier: async (response) => {
      const respJson = await response.json();
      return respJson.payload;
    },
    noAuth: true,
  });
}

export default useSharedAlarmGroup;
